/**
* 风控的设备详情
*/
<template>
	<div style="display: flex;flex-direction: column; height: 100vh; margin: 0px 20px;">

		<!-- 数据加载提示框 -->
		<van-overlay :show="loadingData" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>


		<div style="margin:20px 0px;">

			<el-alert v-show="successfulOperation" title="操作成功" type="success" :description="message" center show-icon>
			</el-alert>

			<el-alert v-show="operationFailed" title="操作失败" type="error" :description="message" center show-icon>
			</el-alert>

		</div>

		<el-row type="flex" justify="center ">
			<span style="width: 2%;" />
			<el-button style="width: 30%;" type="warning" @click="banAccount()">{{ text02 }}</el-button>
			<span style="width: 3%;" />
			<el-button style="width: 30%;" type="danger" @click="addBlacklist()">{{ text01 }}</el-button>
			<span style="width: 3%;" />
			<el-button style="width: 30%;" type="danger" @click="addBlackIp()">{{ text03 }}</el-button>
			<span style="width: 2%;" />
		</el-row>

		<el-descriptions :column="4" border style="padding-bottom: 60px; margin-top: 20px;">
			<el-descriptions-item label="设备ID">{{ handleEmptyDeviceDetail(data.deviceId)}}</el-descriptions-item>

			<el-descriptions-item label="设备操作系统">
				<el-tag size="small">{{handleEmptyDeviceDetail(data.deviceOs)}}</el-tag>
			</el-descriptions-item>

			<el-descriptions-item label="风险工具">{{ handleEmptyDeviceDetail(data.installedTools) }}</el-descriptions-item>

			<el-descriptions-item
				label="sequenceId">{{ handleEmptyDeviceDetail(data.sequenceId) }}</el-descriptions-item>

			//deviceDetail 里面的数据

			<el-descriptions-item
				label="Android ID">{{handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.android_id)}}
			</el-descriptions-item>

			<el-descriptions-item
				label="Android API 版本">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.api_version)}}
			</el-descriptions-item>

			<el-descriptions-item
				label="app 版本">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.app_version)}}
			</el-descriptions-item>

			<el-descriptions-item
				label="可用内存大小">{{handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.available_memory)}}
			</el-descriptions-item>

			<el-descriptions-item
				label="可用存储大小">{{handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.available_storage)}}
			</el-descriptions-item>

			<el-descriptions-item
				label="基带版本">{{handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.baseband_version)}}
			</el-descriptions-item>

			<el-descriptions-item
				label="电量">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.battery_level)}}
			</el-descriptions-item>

			<el-descriptions-item
				label="设备品牌">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.brand)}}
			</el-descriptions-item>

			<el-descriptions-item
				label="无线 MAC 地址">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.bssid)}}
			</el-descriptions-item>

			<el-descriptions-item
				label="移动运营商">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.carrier) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="本地 IP 地址">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.cell_ip) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="充电状态">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.charge_state) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="国家代码">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.country_iso) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="CPU 硬件">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.cpu_hardware) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="CPU 型号">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.cpu_type) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="当前时间">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.current_time)}}
			</el-descriptions-item>

			<el-descriptions-item
				label="设备名称">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.device_name)}}
			</el-descriptions-item>

			<el-descriptions-item
				label="设备软件版本号">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.device_svn) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="DNS 地址">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.dns_address) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="SDK 版本">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.fp_version) }}
			</el-descriptions-item>

			<el-descriptions-item label="地址" v-if="data.deviceDetail && data.deviceDetail.gps_location">
				{{ data.deviceDetail.gps_location.address }}
			</el-descriptions-item>
			<el-descriptions-item label="地址" v-else>-</el-descriptions-item>

			<el-descriptions-item
				label="市">{{ data.deviceDetail && data.deviceDetail.gps_location ? data.deviceDetail.gps_location.city : '-' }}</el-descriptions-item>
			<el-descriptions-item
				label="省">{{ data.deviceDetail && data.deviceDetail.gps_location ? data.deviceDetail.gps_location.province : '-' }}</el-descriptions-item>
			<el-descriptions-item
				label="省/州/地区">{{ data.deviceDetail && data.deviceDetail.gps_location ? data.deviceDetail.gps_location.region : '-' }}</el-descriptions-item>
			<el-descriptions-item
				label="镇">{{ data.deviceDetail && data.deviceDetail.gps_location ? data.deviceDetail.gps_location.township : '-' }}</el-descriptions-item>



			<el-descriptions-item
				label="硬件">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.hardware) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="HOST">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.host) }}
			</el-descriptions-item>

			<el-descriptions-item label="ip">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.ip) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="ipv6">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.ipv6) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="语言">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.language) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="纬度">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.latitude) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="经度">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.longitude) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="移动国家码">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.mcc) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="移动网络码">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.mnc) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="设备型号">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.model) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="网络类型">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.network_type) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="应用包名">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.package_name) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="产品代号">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.product) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="代理配置">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.proxy_info) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="运行的应用包名">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.running_packages) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="屏幕亮度">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.screen_brightness) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="屏幕分辨率">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.screen_resolution) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="签名 MD5">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.sign_md5) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="SIM 卡运营商">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.sim_operator) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="开机时间">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.startup_time) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="Android 系统版本">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.system_version) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="时区">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.time_zone) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="总内存大小">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.total_memory)}}
			</el-descriptions-item>

			<el-descriptions-item
				label="总存储大小">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.total_storage) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="开机时长">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.up_time) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="VPN IP 地址">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.vpn_ip) }}
			</el-descriptions-item>

			<el-descriptions-item
				label="无线IP地址">{{ handleEmptyDeviceDetail(data.deviceDetail && data.deviceDetail.wifi_ip) }}
			</el-descriptions-item>

		</el-descriptions>

	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				sequenceId: '', //信息序号
				deviceId: '', //设备ID
				userId: '', //用户ID
				country: '', //国码
				id: '', //记录的ID
				phoneNumber: '', //手机号
				ip: '', //IP
				data: '', //接口返回的数据
				message: "", //提示的内容
				successfulOperation: false, //操作成功
				operationFailed: false, //操作失败
				deviceBaned: 0, // 该设备是否已被封禁 0-正常 1-已被封禁
				accountBaned: 0, //账号是否已被封禁  -3-用户已操作注销， 0-正常， 1-被禁言， 2-封号(未解绑设备) ，4-封号(已解绑设备) 
				ipBanded: 0, //0正常 1被封
				text01: "", //设备被封文本
				text02: "", //账号被封文本
				text03: "", //封禁IP
				//...
			};
		},
		mounted() {
			this.sequenceId = this.$route.query.sequenceId;
			this.deviceId = this.$route.query.deviceId;
			this.userId = this.$route.query.userId;
			this.country = this.$route.query.country;
			this.id = this.$route.query.id;
			this.phoneNumber = this.$route.query.phoneNumber;
			this.ip = this.$route.query.ip;

			console.log('sequenceId:', this.sequenceId);
			console.log('userId:', this.userId);
			console.log('country:', this.country);
			console.log('id:', this.id);
			console.log('phoneNumber:', this.phoneNumber);
			console.log('ip:', this.ip);

			this.fetchData();
		},
		methods: {
			fetchData() { //用户详情
				this.loadingData = true;

				const requestData = {}; //传递的参数
				requestData.sequenceId = this.sequenceId;
				requestData.userId = this.userId;

				axios.post(this.$p_url + '/admin/fingerprint/detail', requestData, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("后台数据返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.data = response.data.data;
							this.deviceBaned = response.data.data.deviceBaned;
							this.accountBaned = response.data.data.accountBaned;
							this.ipBanded = response.data.data.ipBanded;

							switch (this.deviceBaned) { //该设备是否已被封禁
								case 0: //正常
									this.text01 = "封禁设备";
									break
								case 1: //已被封禁
									this.text01 = "该设备已经被封";
									break
							}

							switch (this.accountBaned) { //账号是否已被封禁
								case -3: //用户已操作注销
									this.text02 = "用户已操作注销";
									break
								case 0: //正常
									this.text02 = "封禁账号";
									break
								case 1: //被禁言
									this.text02 = "该账号被禁言";
									break
								case 2: //封号(未解绑设备)
									this.text02 = "被封号(未解绑设备)";
									break
								case 4: //封号(已解绑设备)
									this.text02 = "已封号(已解绑设备)";
									break
							}

							switch (this.ipBanded) { //IP是否已被封禁
								case 0: //正常
									this.text03 = "封禁IP";
									break
								case 1: //已被封禁
									this.text03 = "IP被封";
									break
							}


						} else {
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
					});
			},
			banAccount() { //封禁账号
				if (this.accountBaned == 0) {
					this.loadingData = true;
					axios.get(this.$p_url + '/admin/black/' + this.userId, {
							withCredentials: true, // 允许跨域携带 cookie
							headers: {
								'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
						.then(response => {
							this.loadingData = false;
							console.log("封禁账号 返回的值：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								this.message = "封禁账号成功!";
								this.successfulOperation = true;
								this.fetchData();
							} else { // 处理状态为失败的情况
								this.message = response.data.message;
								this.operationFailed = true;
							}
						})
						.catch(error => { // 请求失败时处理错误
							this.loadingData = false;
							alert("请求失败：" + error);
						});
				}
			},
			addBlacklist() { //封禁设备
				if (this.deviceBaned == 0) {
					this.loadingData = true;

					const requestData = {}; //传递的参数
					requestData.country = this.country;
					requestData.deviceId = this.deviceId
					requestData.id = this.id
					requestData.phoneNumber = this.phoneNumber;
					requestData.userId = this.userId;

					axios.post(this.$p_url + '/admin/forbidden/deviceId', requestData, {
							withCredentials: true, // 允许跨域携带 cookie
							headers: {
								'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
						.then(response => {
							this.loadingData = false;
							console.log("后台数据返回：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								this.message = "封禁设备成功!";
								this.successfulOperation = true;
								this.fetchData();
							} else {
								this.message = response.data.message;
								this.operationFailed = true;
							}
						})
						.catch(error => { // 请求失败时处理错误
							this.loadingData = false;
							alert('请求失败:' + error);
						});
				}
			},
			addBlackIp() { //封禁IP
				if (this.ipBanded == 0) {
					this.loadingData = true;

					const requestData = {};
					requestData.ip = this.ip;
					requestData.country = this.country;
					requestData.deviceId = this.deviceId
					requestData.id = this.id
					requestData.phoneNumber = this.phoneNumber;
					requestData.userId = this.userId;

					axios.post(this.$p_url + '/admin/forbidden/ip', requestData, {
							withCredentials: true,
							headers: {
								'Content-Type': 'application/json',
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
						.then(response => {
							this.loadingData = false;
							console.log("封禁IP：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								this.message = "封禁IP成功!";
								this.successfulOperation = true;
								this.fetchData();
							} else {
								this.message = response.data.message;
								this.operationFailed = true;
							}
						})
						.catch(error => { // 请求失败时处理错误
							this.loadingData = false;
							alert('请求失败:' + error);
						});
				}
			},
			handleEmptyDeviceDetail(value) {
				return value ? value : '-'; // 如果值为空，则返回占位符 '-'
			}
			//...
		},

		//....
	}
</script>

<style>
</style>